import GtmAddToBasketDelegator from './gtmAddToBasketDelegator';
import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmBasketFreeGiftDelegator {
	constructor() {
		this.type = GtmTrackingType.BASKET_FREE_GIFT;
	}

	getTrackingData() {
		const { freeGiftsAdded, freeGiftsRemoved } = window.dataLayer[0];
		const freeGiftData = [];

		if (freeGiftsAdded) {
			freeGiftData.push(
				...GtmAddToBasketDelegator.getTrackingData(null, {
					addToCart: freeGiftsAdded,
				}),
			);
		}

		if (freeGiftsRemoved) {
			freeGiftData.push(
				this.generateRemovalDataLayerTrackingObject(freeGiftsRemoved),
			);
		}

		return freeGiftData;
	}

	generateRemovalDataLayerTrackingObject(freeGiftsRemoved) {
		return {
			event: 'removeFromCart',
			ecommerce: {
				remove: {
					actionField: {
						list: TrackingHelperInstance.generateActionFieldString(),
					},
					products: this.mapProductDataForGA(freeGiftsRemoved),
				},
			},
		};
	}

	mapProductDataForGA(products) {
		return products.map(product => ({
			id: product.skuID,
			quantity: product.skuQty,
			name: product.skuTitle,
			price: product.skuPriceexVAT,
			category: product.skuCategory || 'undefined',
			position: product.indexIterator || 'undefined',
			brand: 'undefined',
			variant: 'undefined',
		}));
	}
}

const GtmBasketFreeGiftDelegatorInstance = new GtmBasketFreeGiftDelegator();
export default GtmBasketFreeGiftDelegatorInstance;

// for test purpose only
export const GtmBasketFreeGiftDelegatorClass = GtmBasketFreeGiftDelegator;
